import { Document, DocumentHeader } from '@h5s/dtos-api';
import { dateTimeToString } from '@h5s/util-date';
import { MappedClass, MappedProperty, MappedPropertyDateTime } from '@h5s/util-object';
import { DateTime } from 'luxon';

@MappedClass()
export class CashRegisterCreditNote {
  @MappedProperty()
  public closure: string;

  @MappedPropertyDateTime()
  public date: DateTime;

  @MappedProperty()
  public documentNumber: string;
}

export function mapCashRegisterCreditNoteToZPrinterDocument(
  creditNote: CashRegisterCreditNote,
  printerId: string,
): Document {
  /*
   * Header
   */
  const documentHeader: DocumentHeader = {
    return_info: {
      closure: parseInt(creditNote.closure),
      date: dateTimeToString(creditNote.date),
      number: parseInt(creditNote.documentNumber),
    },
  };

  return {
    document_type: 'cancel_receipt',
    device_id: printerId,
    header: documentHeader,
    body: {},
    footer: {},
  };
}
